import Agents from './Agents'
import Settings from './Settings'
import Invoices from './Invoices'

export default [
  { path: '/partner/organization/agents', component: Agents, meta: { auth: true }, },
  { path: '/partner/organization/settings', component: Settings, meta: { auth: true }, },
  { path: '/partner/organization/invoices', component: Invoices, meta: { auth: true }, },
]